<template>
  <form @submit.prevent="onSubmit">
    <div
      class="flex flex-col p-10 rounded-b-2xl border border-solid border-transparent [background:linear-gradient(108.54deg,#D0D0D0_-0.99%,#838383_187.83%)_padding-box,linear-gradient(130.54deg,#C9C9C9_-15.61%,#7B7B7B_121.33%)_border-box]"
    >
      <ControlForm
        class="col-span-full"
        label="Логин"
        error-style="mt-1"
        :control="email"
      >
        <template #field="{ invalid }">
          <InputText
            id="email"
            v-model="email.value"
            class="w-full h-8 rounded-[10px]"
            :invalid="invalid"
            :disabled="email.disabled"
            @blur="email.setTouched()"
          />
        </template>
      </ControlForm>

      <ControlForm
        class="col-span-full"
        label="Пароль"
        error-style="mt-1"
        :control="password"
      >
        <template #field="{ invalid }">
          <Password
            id="password"
            v-model="password.value"
            toggleMask
            input-class="w-full h-8 rounded-[10px]"
            :invalid="invalid"
            :feedback="false"
            :disabled="password.disabled"
            @blur="password.setTouched()"
          />
        </template>
      </ControlForm>

      <div class="flex flex-col justify-center items-center gap-4 mt-8">
        <Button
          type="submit"
          class="w-full max-w-[210px] bg-[#E2FF32] text-[#262626] text-base font-semibold w-[210px] h-[42px] rounded-2xl border-none !shadow-none"
          :label="buttonLabel"
          :loading="loginPending"
          :disabled="form.disabled"
        ></Button>
        <Button
          class="w-[210px] bg-white rounded-2xl transition-all duration-200 border-none !shadow-none justify-center"
          @click="navigateToRegister"
        >
          <a
            :href="registerRedirectLink"
            target="_blank"
            class="block font-[Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'] font-semibold text-[#262626] text-base no-underline h-full w-full"
          >
            Зарегистрироваться
          </a>
        </Button>
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import { useModel } from '../../model';
import { ControlForm, emailValidator, isDev } from '@/shared';
import { useForm } from '@/shared/form';
import { storeToRefs } from 'pinia';
import Button from 'primevue/button';
import Password from 'primevue/password';
import InputText from 'primevue/inputtext';
import { computed } from 'vue';

type LoginForm = {
  email: string;
  password: string;
};

const model = useModel();

const { login } = model;
const { loginPending } = storeToRefs(model);

const registerRedirectLink = computed(() =>
  isDev() ? 'https://my-test.inpocket.ru/auth/register' : 'https://my.inpocket.ru/auth/register'
);

function requiredFieladValidator(value: unknown) {
  if (value) return true;

  return 'Поле обязательное';
}

const form = useForm<LoginForm>({
  email: {
    validators: [requiredFieladValidator, emailValidator]
  },
  password: {
    validators: [requiredFieladValidator]
  }
});

const navigateToRegister = () => {
  window.open(registerRedirectLink.value, '_blank');
};

const { email, password } = form.controls;

const buttonLabel = computed(() => {
  if (loginPending.value) {
    return 'Авторизация...';
  }

  return 'Войти';
});

async function onSubmit() {
  if (loginPending.value) return;

  const formIsValid = await form.validate();

  if (formIsValid) {
    const values = form.getValues() as LoginForm;
    await login(values);
  }
}
</script>
